import { useMemo, useState } from "react"
import { cleanObject } from "utils"

const useAdvancedTableFilters = ({ defaultFilters = {} } = {}) => {
  const [advancedFilters, setAdvancedFilters] = useState(defaultFilters ?? {})

  const { isFiltersEmpty, cleanedFilters } = useMemo(() => {
    const cleaned = cleanObject(advancedFilters ? { ...advancedFilters } : {})
    return {
      isFiltersEmpty: Object.keys(cleaned).length === 0,
      cleanedFilters: cleaned,
    }
  }, [advancedFilters])

  const resetFilters = () => setAdvancedFilters(defaultFilters ?? {})

  return {
    advancedFilters,
    setAdvancedFilters,
    isFiltersEmpty,
    cleanedFilters,
    resetFilters,
  }
}

export default useAdvancedTableFilters
